import styled from 'styled-components';
import { Input } from 'antd';

/**
 * AddressPickerV2 Styled Components
 *
 * Styled components for AddressPicker UI elements.
 * Matches existing form styling patterns in the application.
 */

export const InputWrapper = styled.div`
	position: relative;
	width: 100%;

	/* Ensure Google Places Autocomplete dropdown is visible */
	.pac-container {
		z-index: 10000 !important;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		margin-top: 4px;
	}

	.pac-item {
		padding: 10px 14px;
		cursor: pointer;
		border-top: 1px solid #e6e6e6;
		font-size: 14px;
	}

	.pac-item:first-child {
		border-top: none;
	}

	.pac-item:hover {
		background-color: #f1f3f4;
	}

	.pac-item-selected,
	.pac-item-selected:hover {
		background-color: #e8f0fe;
	}

	.pac-icon {
		margin-right: 8px;
	}

	.pac-matched {
		font-weight: 600;
	}
`;

export const AddressInput = styled(Input)`
	width: 100%;
	padding-right: 42px;

	&:focus {
		border-color: #2563eb;
		box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
	}
`;

const SideButton = styled.button`
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	cursor: pointer;
	border: none;
	border-radius: 50%;
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
	transition: all 0.2s ease;
	z-index: 1;

	&:hover {
		transform: translateY(-50%) scale(1.05);
	}

	&:active {
		transform: translateY(-50%) scale(0.95);
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.55;
	}

	svg {
		width: 16px;
		height: 16px;
	}
`;

export const MapIconButton = styled(SideButton)`
	background: #131314ff;

	&:hover {
		background: #121213ff;
		transform: translateY(-50%) scale(1.03);
	}

	&:disabled {
		background: #d1d5db;
	}

	svg {
		fill: #fff;
	}
`;

export const ClearIconButton = styled(SideButton)`
	background: transparent;
	color: #8c8c8c;

	&:hover {
		background: transparent;
		color: #595959;
		transform: translateY(-50%);
	}

	&:active {
		transform: translateY(-50%);
	}

	&:disabled {
		background: transparent;
	}

	svg {
		color: currentColor;
	}
`;

export const SuggestionsDropdown = styled.ul`
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	z-index: 10000;
	background: #fff;
	border: 1px solid #e6e6e6;
	border-radius: 8px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	margin: 0;
	padding: 4px 0;
	list-style: none;
	max-height: 400px;
	overflow-y: auto;
`;

export const SuggestionItem = styled.li`
	padding: 10px 14px;
	cursor: pointer;
	font-size: 14px;
	border-top: 1px solid #f0f0f0;
	display: flex;
	flex-direction: column;
	gap: 2px;

	&:first-child {
		border-top: none;
	}

	&:hover,
	&.active {
		background-color: #f1f3f4;
	}

	.suggestion-main {
		font-weight: 500;
		color: #1a1a1a;
	}

	.suggestion-secondary {
		font-size: 12px;
		color: #6b7280;
	}
`;

export const MapModalContainer = styled.div`
	.map-modal-overlay {
		position: fixed;
		inset: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 1000;
	}

	.map-container {
		width: 100%;
		height: 600px;
		min-height: 600px;
		background: white;
		overflow: hidden;
		position: relative;
	}

	.map-wrapper {
		width: 100%;
		height: 600px;
		min-height: 600px;
	}

	#map {
		width: 100% !important;
		height: 600px !important;
		min-height: 600px;
	}
`;
